import React, {useEffect, useState} from "react";
import ModalWrapper from "./modalWrapper";
import '../../styles/ModalStylesheet.scss';
import '../../styles/FormStylesheet.scss';
import SignInOptionsContent from "../signIn/signInOptionsContent";
import {useIsMobile} from "../../common/hooks/useIsMobile";

interface LoginModalProps {
    openModal: boolean, 
    onComplete: () => void,
    onClose: () => void,
}

const LoginModal : React.FC<LoginModalProps> = ({openModal=false, onComplete, onClose}) => {

    const isMobile = useIsMobile();
    const [modalHeight, setModalHeight] = useState<string>();

    useEffect(() => {
        setModalHeight(isMobile ? undefined : '610px');

        const handleResize = () => {
            if(window.innerHeight < 700){
                setModalHeight(undefined);
                return;
            }

            setModalHeight(isMobile ? undefined : '610px');
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <ModalWrapper 
            openModal={openModal} 
            onClose={onClose} 
            modalFixedHeight={modalHeight}
        >
            <SignInOptionsContent
                flex={1}
                py={2}
                onComplete={onComplete}
            />
        </ModalWrapper>
    );
}

export default LoginModal;